// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"aac4a418","342":"1afae3d2","361":"008009f7","560":"bc4a9377","742":"b18dee8f"}[chunkId] + ".chunk.js";
};